export default "__VITE_ASSET__Dy6aG3ui__"